import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import '../_Modal.scss'
import './_Login.scss'
import { selectUser } from '../../../redux/systemSlice'
import useCheckout from '../../../hooks/checkout'
import { useAuth } from '../../../contexts/Auth'
import Button from '../../Buttons'
import Modal from '../Modal'
import SignupContent from './Signup'
import LoginContent from './Login'
import { atom, useAtom } from 'jotai'
import useIsPremium from '../../../hooks/useIsPremium'

type ModalAtomSchema = {
	goToCheckout: boolean
	checkoutContext?: string
}

const defaultValues: ModalAtomSchema = {
	goToCheckout: false,
	checkoutContext: undefined,
}

export const modalAtom = atom<ModalAtomSchema>(defaultValues)

function LoginModal({
	open,
	setModalOpen,
	premiumPath,
	loginVariant = 'login',
	annualPlan,
	setSubscriptionModalOpen,
	context,
}: {
	open: boolean
	setModalOpen: (open: boolean) => void
	premiumPath?: boolean
	loginVariant?: 'login' | 'signup'
	annualPlan: boolean
	setSubscriptionModalOpen?: (open: boolean) => void
	context: string
}) {
	const user = useSelector(selectUser)
	const [variant, setVariant] = useState<'login' | 'signup'>(premiumPath ? 'signup' : loginVariant)
	const { currentUser } = useAuth() as any
	const [forgotPassword, setForgotPassword] = useState(false)
	const [loginModalState, setLoginModalState] = useAtom(modalAtom)
	const isPremium = useIsPremium()

	const goToCheckout = loginModalState.goToCheckout
	const setGoToCheckout = (goToCheckout: boolean) => {
		setLoginModalState({ goToCheckout, checkoutContext: context })
		setModalOpen(false)
	}

	useEffect(() => {
		if (
			currentUser &&
			goToCheckout &&
			user &&
			user.uid &&
			!isPremium &&
			['create', 'dashboard'].includes(context ?? '')
		) {
			setSubscriptionModalOpen?.(true)
			setModalOpen(false)
			setGoToCheckout(false)
		}
	}, [currentUser, goToCheckout, user, annualPlan, loginModalState.checkoutContext])

	useEffect(() => {
		if (premiumPath) {
			setVariant('signup')
		}
	}, [premiumPath])

	let modalContent = <></>

	if (variant === 'login') {
		modalContent = (
			<LoginContent
				setModalOpen={setModalOpen}
				premiumPath={!!premiumPath}
				setGoToCheckout={setGoToCheckout}
				setVariant={setVariant}
			/>
		)
	} else if (forgotPassword) {
		modalContent = (
			<>
				<div>
					<h5 className="fancy-font header-md">Forgot Password</h5>
					<p>Check your email for further instructions</p>
				</div>
				<Button
					type="tertiary"
					onClick={() => {
						setForgotPassword(false)
					}}
				>
					<span>Login</span>
				</Button>
			</>
		)
	} else {
		modalContent = (
			<SignupContent
				setVariant={setVariant}
				setModalOpen={setModalOpen}
				premiumPath={premiumPath}
				setGoToCheckout={setGoToCheckout}
			/>
		)
	}

	return (
		<>
			<Modal
				portalClassName={`login v2`}
				open={open}
				closeModal={() => {
					setModalOpen(false)
					// dispatch(setUser(NULL_USER))
					// Sentry.setUser(null)
				}}
			>
				{modalContent}
			</Modal>
		</>
	)
}

export default LoginModal
